module.exports = __webpack_public_path__ + "media/images/default-avatar-cffa25fe7f12fbf707fe2f36374b5d04.png";